import React, { useState, useContext, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme, useMediaQuery } from '@mui/material';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { AuthContext } from 'src/context/AuthContext';

import Modal from '@mui/material/Modal';
import {
  IconButton,
  Backdrop,
  CircularProgress,
  Dialog,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import ViewListIcon from '@mui/icons-material/ViewList';
import CommentIcon from '@mui/icons-material/Comment';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import BookOnlineIcon from '@mui/icons-material/BookOnline';

import CommentsModal from 'src/components/SharedComponent/Scheduling/comment_modal';
import { getScheduleColor } from 'src/utils/scheduleColorUtils';
import ColorLegend from 'src/components/SharedComponent/Scheduling/ColorLegend';
import ViewLeaveModal from 'src/components/SharedComponent/EmployeeLeaves/ViewLeaveModal';
import ViewPrebookingModal from 'src/components/SharedComponent/Prebooking/ViewPrebookingModal';

const { PRIVATE_ROUTE } = API_ROUTES;

const styles = {
  calendar: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    width: '100%',
    margin: 'auto',
    gap: '3px',
    fontFamily: 'Arial, sans-serif',
  },

  header: {
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '8px 4px',
    backgroundColor: '#eee',
    fontSize: 'clamp(10px, 1.5vw, 15px)',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },

  cell: {
    minHeight: '100px',
    border: '1px solid #ccc',
    textAlign: 'center',
    backgroundColor: '#fafafa',
    cursor: 'pointer',
    position: 'relative',
    padding: '0 0 1em',
    overflow: 'hidden',
    minWidth: 0,
  },
  dateCircle: {
    position: 'absolute',
    top: '2px',
    left: '2px',
    borderRadius: '50%',
    fontSize: 'clamp(9px, 1.2vw, 12px)',
  },
  moreItem: {
    fontSize: 'clamp(9px, 1.2vw, 12px)',
    fontWeight: 'bold',
  },
  moreItemCount: {
    fontSize: 'clamp(9px, 1.2vw, 12px)',
    fontWeight: 'normal',
  },
  empty: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'default',
  },
  container: {
    maxWidth: '450px',
    margin: '30px auto',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
  },
  controls: {
    marginBottom: '15px',
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  select: {
    padding: '6px 10px',
    fontSize: '14px',
  },
  taskLeftColumn: {
    color: '#000',
    fontWeight: 'bold',
    backgroundColor: '#e2f0f5',
  },
  taskRightColumn: {
    color: '#000',
    fontWeight: 'bold',
    backgroundColor: '#f1f1f1',
  },
  tableRow: {
    padding: '2px',
    border: 'solid 2px #fff',
  },
  button: {
    padding: '6px 14px',
    fontSize: '14px',
    cursor: 'pointer',
    backgroundColor: '#3DADB5',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
  },
  event: {
    background: '#E0F6F8',
    borderRadius: '3px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    fontSize: 'clamp(8px, 1vw, 12px)',
    borderBottom: '2px solid #fff',
    display: 'block',
  },
};
const style = {
  width: '100%',
  height: 'calc(100vh - 92px)',
  p: { xs: 1, sm: 2, md: 3 },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

const formatDate = (y, m, d) => `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

export default function CalenderView({ openStatus, setCalendar }) {
  const theme = useTheme();
  const isMobilePortrait = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobileLandscape = useMediaQuery('(max-height: 500px) and (orientation: landscape)');
  const isMobile = isMobilePortrait || isMobileLandscape;
  const navigate = useNavigate();

  const handleClose = () => setOpen(false);

  const today = new Date();

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [loading, setLoading] = useState(true);

  const [calanderData, setcalanderData] = useState(null);

  const [expandedDate, setExpandedDate] = useState(null);
  const [selectedDayPopup, setSelectedDayPopup] = useState(null); // { dateKey, dayEvents }
  const [openCommentModal, setCommentModal] = useState(false);
  const [selectedCommentSchedule, setSelectedCommentSchedule] = useState(null);
  const [holidayMap, setHolidayMap] = useState({}); // { 'YYYY-MM-DD': description }
  const [leaveDates, setLeaveDates] = useState([]);
  const [leaveRecords, setLeaveRecords] = useState([]);
  const [viewLeaveModal, setViewLeaveModal] = useState({ open: false, date: '', records: [] });
  const [prebookingDates, setPrebookingDates] = useState([]);
  const [prebookingRecords, setPrebookingRecords] = useState([]);
  const [viewPrebookingModal, setViewPrebookingModal] = useState({ open: false, date: '', records: [] });
  const [tooltipOpenDate, setTooltipOpenDate] = useState(null);
  const [commentCounts, setCommentCounts] = useState({});
  const fetchedCommentIds = React.useRef(new Set());

  const { state } = useContext(AuthContext);
  const { authAxios } = useContext(FetchContext);

  const fetchCommentCount = useCallback(
    async (scheduleId) => {
      if (fetchedCommentIds.current.has(scheduleId)) return;
      fetchedCommentIds.current.add(scheduleId);
      try {
        const res = await authAxios.get(`${PRIVATE_ROUTE?.FETCH_ALL_COMMENTS}?schedule_id=${scheduleId}`);
        const count = (res?.data?.data || []).length;
        setCommentCounts((prev) => ({ ...prev, [scheduleId]: count }));
      } catch {
        // silently ignore — button shows without highlight
      }
    },
    [authAxios]
  );

  const getData = React.useCallback(
    async (yr, mo) => {
      fetchedCommentIds.current.clear();
      setCommentCounts({});
      const { data } = await authAxios.get(`${PRIVATE_ROUTE?.GET_SCHEDULEALL}?year=${yr}&month=${mo}`);

      let schedule_data = {};

      (data.data || []).forEach((schedule) => {
        if (!schedule.group_number || schedule.group_number === 0) return;
        const formatted_date = schedule.planned_date.split('T')[0];
        if (!schedule_data[formatted_date]) {
          schedule_data[formatted_date] = {};
          schedule_data[formatted_date] = {};

          schedule_data[formatted_date][`${schedule.group_number}`] = [];
          schedule_data[formatted_date][`${schedule.group_number}`].push(schedule);
        } else if (schedule_data[formatted_date][`${schedule.group_number}`]) {
          schedule_data[formatted_date][`${schedule.group_number}`].push(schedule);
        } else {
          schedule_data[formatted_date][`${schedule.group_number}`] = [];
          schedule_data[formatted_date][`${schedule.group_number}`].push(schedule);
        }
      });

      setcalanderData(schedule_data);
    },
    [authAxios]
  );

  useEffect(() => {
    getData(year, month);
  }, [year, month, getData]);

  const getHolidays = async (yr) => {
    const { data } = await authAxios.get(`${PRIVATE_ROUTE?.GET_HOLIDAYS}`);
    const map = {};
    (data?.data ?? []).forEach((h) => {
      const dateKey = h.date.split('T')[0];
      if (parseInt(dateKey.substring(0, 4), 10) === yr) {
        map[dateKey] = h.description;
      }
    });
    setHolidayMap(map);
  };

  useEffect(() => {
    getHolidays(year);
  }, [year]);

  const currentUser = state?.user;
  const isAdminOrManager = currentUser?.role === 'admin' || currentUser?.role === 'manager';

  const fetchLeaves = useCallback(async () => {
    try {
      const { data } = await authAxios.get(`${PRIVATE_ROUTE.GET_EMPLOYEE_LEAVES}?year=${year}&month=${month + 1}`);
      const records = data.data || [];
      setLeaveRecords(records);
      // Expand range leaves into individual date strings for the current month
      const mo = month + 1;
      const lastDay = new Date(year, mo, 0).getDate();
      const monthStart = `${year}-${String(mo).padStart(2, '0')}-01`;
      const monthEnd = `${year}-${String(mo).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
      const allDates = [];
      records.forEach((l) => {
        const from = l.date_from?.substring(0, 10);
        if (!from) return;
        const to = l.date_to?.substring(0, 10);
        if (!to || from === to) { allDates.push(from); return; }
        const clampedStart = from > monthStart ? from : monthStart;
        const clampedEnd = to < monthEnd ? to : monthEnd;
        let cur = new Date(`${clampedStart}T00:00:00`);
        const end = new Date(`${clampedEnd}T00:00:00`);
        while (cur <= end) {
          allDates.push(cur.toISOString().substring(0, 10));
          cur.setDate(cur.getDate() + 1);
        }
      });
      setLeaveDates(allDates);
    } catch (e) {
      console.error('Failed to fetch employee leaves', e);
    }
  }, [authAxios, year, month]);

  useEffect(() => {
    fetchLeaves();
  }, [fetchLeaves]);

  const fetchPrebookings = useCallback(async () => {
    try {
      const startDate = `${year}-${String(month + 1).padStart(2, '0')}-01`;
      const lastDay = new Date(year, month + 1, 0).getDate();
      const endDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE.GET_PREBOOKING_DATE_RANGE}?start_date=${startDate}&end_date=${endDate}`
      );
      const records = data.data || [];
      setPrebookingRecords(records);
      setPrebookingDates(records.map((p) => p.date?.substring(0, 10)).filter(Boolean));
    } catch (e) {
      console.error('Failed to fetch prebookings', e);
    }
  }, [authAxios, year, month]);

  useEffect(() => {
    fetchPrebookings();
  }, [fetchPrebookings]);

  // Month names
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectEvent = (e, event, group) => {
    setAnchorEl(e.currentTarget);
    setSelectedEvent({ event: event, group: group });
  };

  const handleClosePop = () => {
    setAnchorEl(null);
    setSelectedEvent(null);
  };

  const handleMoreClick = (dateKey) => {
    setExpandedDate((prev) => (prev === dateKey ? null : dateKey));
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const years = Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);

  // Get total days in month
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // Get first day of month (0 = Sunday)
  const firstDay = new Date(year, month, 1).getDay();

  // Create empty cells before first day
  const blanks = Array(firstDay).fill(null);

  // Create days array
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const groupColors = ['#65C8D0', '#4BBBC4', '#3DADB5', '#52C1CA', '#7DD4DB', '#2E9DA6'];

  const handleSubmit = () => {
    setYear(selectedYear);
    setMonth(selectedMonth);
  };

  return (
    <div>
      {openCommentModal && selectedCommentSchedule && (
        <CommentsModal
          opentStatus={openCommentModal}
          setCommentModal={setCommentModal}
          selectedSchedule={selectedCommentSchedule}
          user={state.user}
          onCommentAdded={() =>
            setCommentCounts((prev) => ({
              ...prev,
              [selectedCommentSchedule._id]: (prev[selectedCommentSchedule._id] || 0) + 1,
            }))
          }
        />
      )}
      <Box id="arun" sx={style}>
        <Box
          sx={{
            display: 'flex',
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'space-between',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? 1 : 0,
            mb: 2,
            padding: '0.5em',
          }}
        >
          {/* Left Side - Title */}
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#2a2a2a' }}>
            Job Scheduling
          </Typography>

          {/* Right Side - Month / Year / Button */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            {/* Month Select */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {state?.user?.role !== 'employee' && (
                <ViewListIcon
                  sx={{ fontSize: 20, color: 'text.secondary', cursor: 'pointer' }}
                  onClick={() => navigate('/scheduling/list')}
                />
              )}
              <select
                style={styles.select}
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
              >
                {months.map((m, index) => (
                  <option key={m} value={index}>
                    {m}
                  </option>
                ))}
              </select>
            </Box>

            {/* Year Select */}
            <select
              style={styles.select}
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>

            {/* Submit Button */}
            <Button variant="contained" onClick={handleSubmit}>
              Submit
            </Button>
          </Box>
        </Box>

        {/* Estimated Hours Legend */}
        <ColorLegend />

        <div style={{ overflowY: 'auto', flex: 1 }}>
          <div style={styles.calendar}>
            {/* Headers */}
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
              <div key={day} style={styles.header}>
                {day}
              </div>
            ))}

            {/* Empty cells */}
            {blanks.map((_, index) => (
              <div
                key={`blank-${index}`}
                style={{
                  ...styles.cell,
                  ...styles.empty,
                  minHeight: isMobile ? '60px' : '130px',
                  height: isMobile ? '60px' : '130px',
                }}
              />
            ))}

            {/* Days */}
            {days.map((day) => {
              const dateKey = formatDate(year, month, day);
              const isToday = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();

              let dayEvents = calanderData && calanderData[dateKey] ? calanderData[dateKey] : null;

              let groups = dayEvents ? Object.keys(dayEvents) : [];
              const isExpanded = expandedDate === dateKey;
              const isHoliday = Boolean(holidayMap[dateKey]);
              const holidayDescription = holidayMap[dateKey];

              const visibleEvents = dayEvents || null;
              const allGroupKeys = visibleEvents ? Object.keys(visibleEvents) : [];
              const visibleGroupKeys = allGroupKeys.slice(0, 2);
              const hiddenCount = allGroupKeys.length - 2;

              return (
                <div
                  key={day}
                  style={{
                    ...styles.cell,
                    backgroundColor: isHoliday ? '#FFF8F8' : isToday ? '#f0fafb' : '#fafafa',
                    borderLeft: isHoliday ? '3px solid #d32f2f' : '1px solid #ccc',
                    height: isMobile ? '60px' : '130px',
                    minHeight: isMobile ? '60px' : '130px',
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  {/* Leave & Prebooking icons — top-left corner, side by side */}
                  <div style={{ position: 'absolute', top: 2, left: 2, display: 'flex', gap: 2, zIndex: 1 }}>
                    {leaveDates.includes(dateKey) && (
                      <Tooltip title="Employee Leave" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={() =>
                            setViewLeaveModal({
                              open: true,
                              date: dateKey,
                              records: leaveRecords.filter((l) => {
                                const from = l.date_from?.substring(0, 10);
                                if (!from) return false;
                                const to = l.date_to?.substring(0, 10);
                                if (!to) return from === dateKey;
                                return dateKey >= from && dateKey <= to;
                              }),
                            })
                          }
                          sx={{ p: '2px', color: '#F59E0B', '&:hover': { backgroundColor: '#FEF3C7' } }}
                        >
                          <EventBusyIcon sx={{ fontSize: 'clamp(11px, 1.2vw, 15px)' }} />
                        </IconButton>
                      </Tooltip>
                    )}
                    {prebookingDates.includes(dateKey) && (
                      <Tooltip title="Prebooking" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={() =>
                            setViewPrebookingModal({
                              open: true,
                              date: dateKey,
                              records: prebookingRecords.filter((p) => p.date?.substring(0, 10) === dateKey),
                            })
                          }
                          sx={{ p: '2px', color: '#7C3AED', '&:hover': { backgroundColor: '#EDE9FE' } }}
                        >
                          <BookOnlineIcon sx={{ fontSize: 'clamp(11px, 1.2vw, 15px)' }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>

                  {/* Date number + holiday text (desktop) or tooltip (mobile) */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      padding: '3px 5px 2px',
                      gap: '4px',
                      minWidth: 0,
                    }}
                  >
                    {isHoliday && !isMobile && (
                      <span
                        style={{
                          fontSize: 'clamp(7px, 0.75vw, 9px)',
                          fontWeight: 600,
                          fontStyle: 'italic',
                          color: '#d32f2f',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {holidayDescription}
                      </span>
                    )}
                    <Tooltip
                      title={holidayDescription || ''}
                      placement="top"
                      arrow
                      open={isHoliday ? tooltipOpenDate === dateKey : false}
                      disableHoverListener
                      disableFocusListener
                      disableTouchListener
                    >
                      <span
                        role={isHoliday ? 'button' : undefined}
                        tabIndex={isHoliday ? 0 : undefined}
                        onClick={
                          isHoliday
                            ? (e) => {
                                e.stopPropagation();
                                setTooltipOpenDate((prev) => (prev === dateKey ? null : dateKey));
                              }
                            : undefined
                        }
                        onKeyDown={
                          isHoliday
                            ? (e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.stopPropagation();
                                  setTooltipOpenDate((prev) => (prev === dateKey ? null : dateKey));
                                }
                              }
                            : undefined
                        }
                        style={{
                          width: 22,
                          height: 22,
                          borderRadius: '50%',
                          backgroundColor:
                            isToday && isHoliday
                              ? '#d32f2f'
                              : isToday
                              ? '#3DADB5'
                              : isHoliday
                              ? '#ffebee'
                              : 'transparent',
                          color: isToday ? '#fff' : isHoliday ? '#d32f2f' : '#333',
                          fontWeight: isToday || isHoliday ? 'bold' : '500',
                          fontSize: 'clamp(10px, 1.1vw, 13px)',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          lineHeight: 1,
                          flexShrink: 0,
                          border: isHoliday && !isToday ? '1px solid #ef9a9a' : 'none',
                          cursor: isMobile && isHoliday ? 'pointer' : 'default',
                        }}
                      >
                        {day}
                      </span>
                    </Tooltip>
                  </div>

                  {/* Mobile: Show Details button */}
                  {isMobile ? (
                    allGroupKeys.length > 0 && (
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '2px',
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => setSelectedDayPopup({ dateKey, dayEvents })}
                          style={{
                            fontSize: '8px',
                            fontWeight: '700',
                            color: '#fff',
                            background: '#3DADB5',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '3px 5px',
                            cursor: 'pointer',
                            width: '100%',
                          }}
                        >
                          View
                        </button>
                      </div>
                    )
                  ) : (
                    <>
                      {/* Group event chips */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '2px',
                          padding: '0 3px',
                          overflowY: 'hidden',
                          flex: 1,
                          minHeight: 0,
                        }}
                      >
                        {visibleGroupKeys.map((group, index) => {
                          const color = groupColors[index % groupColors.length];
                          const members = visibleEvents[group][0]?.assigned_members
                            ? visibleEvents[group][0].assigned_members
                                .map((m) => `${m.first_name} ${m.last_name}`)
                                .join(', ')
                            : '';

                          return (
                            <div key={group}>
                              <button
                                type="button"
                                onClick={(e) => handleSelectEvent(e, dayEvents[group], group)}
                                style={{
                                  width: '100%',
                                  display: 'block',
                                  background: `${color}18`,
                                  borderLeft: `3px solid ${color}`,
                                  borderTop: 'none',
                                  borderRight: 'none',
                                  borderBottom: 'none',
                                  borderRadius: '0 3px 3px 0',
                                  padding: '2px 5px',
                                  cursor: 'pointer',
                                  textAlign: 'left',
                                  overflow: 'hidden',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 3,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: 'clamp(9px, 1vw, 11px)',
                                      fontWeight: '600',
                                      color,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      flexShrink: 1,
                                      minWidth: 0,
                                    }}
                                  >
                                    Group {group}
                                  </span>
                                  <span
                                    style={{
                                      background: color,
                                      color: '#fff',
                                      borderRadius: '8px',
                                      padding: '0 5px',
                                      fontSize: 'clamp(8px, 0.85vw, 10px)',
                                      fontWeight: '700',
                                      flexShrink: 0,
                                      lineHeight: '14px',
                                    }}
                                  >
                                    {visibleEvents[group].length}
                                  </span>
                                </div>
                                {members && (
                                  <div
                                    style={{
                                      fontSize: 'clamp(8px, 0.8vw, 10px)',
                                      color: '#666',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      marginTop: '1px',
                                    }}
                                  >
                                    {members}
                                  </div>
                                )}
                              </button>
                            </div>
                          );
                        })}
                      </div>

                      {/* More / Less toggle */}
                      {hiddenCount > 0 && (
                        <button
                          type="button"
                          onClick={() => setSelectedDayPopup({ dateKey, dayEvents })}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '2px',
                            margin: '2px 3px 2px',
                            padding: '3px 6px',
                            border: `1px solid #3DADB5`,
                            borderRadius: '10px',
                            background: 'rgba(61,173,181,0.08)',
                            color: '#3DADB5',
                            fontSize: 'clamp(7px, 0.8vw, 10px)',
                            fontWeight: '700',
                            cursor: 'pointer',
                            letterSpacing: '0.2px',
                            width: 'calc(100% - 6px)',
                            lineHeight: '1.6',
                          }}
                        >
                          {`+${hiddenCount} more`}
                        </button>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Box>

      <ViewLeaveModal
        open={viewLeaveModal.open}
        onClose={() => setViewLeaveModal({ open: false, date: '', records: [] })}
        date={viewLeaveModal.date}
        records={viewLeaveModal.records}
        isAdminOrManager={isAdminOrManager}
      />

      <ViewPrebookingModal
        open={viewPrebookingModal.open}
        onClose={() => setViewPrebookingModal({ open: false, date: '', records: [] })}
        date={viewPrebookingModal.date}
        records={viewPrebookingModal.records}
      />

      {/* Mobile Day Detail Popup */}
      <Dialog
        open={Boolean(selectedDayPopup)}
        onClose={() => setSelectedDayPopup(null)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 2, overflow: 'hidden', maxHeight: '80vh', display: 'flex', flexDirection: 'column' },
        }}
      >
        {selectedDayPopup &&
          (() => {
            const allKeys = Object.keys(selectedDayPopup.dayEvents);
            return (
              <>
                <Box
                  sx={{
                    background: '#3DADB5',
                    color: '#fff',
                    px: 2.5,
                    py: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexShrink: 0,
                  }}
                >
                  <Box>
                    <Typography sx={{ opacity: 0.85, fontSize: '0.7rem', letterSpacing: 1, fontWeight: 600 }}>
                      DAY SCHEDULE
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                      {selectedDayPopup.dateKey}
                    </Typography>
                    <Typography sx={{ opacity: 0.85, fontSize: '0.78rem' }}>
                      {allKeys.length} group{allKeys.length !== 1 ? 's' : ''}
                    </Typography>
                  </Box>
                  <IconButton size="small" onClick={() => setSelectedDayPopup(null)} sx={{ color: '#fff' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Box sx={{ overflowY: 'auto', flex: 1, p: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {allKeys.map((group, index) => {
                    const color = groupColors[index % groupColors.length];
                    const members = selectedDayPopup.dayEvents[group][0]?.assigned_members
                      ? selectedDayPopup.dayEvents[group][0].assigned_members
                          .map((m) => `${m.first_name} ${m.last_name}`)
                          .join(', ')
                      : '';
                    return (
                      <button
                        key={group}
                        type="button"
                        onClick={(e) => {
                          handleSelectEvent(e, selectedDayPopup.dayEvents[group], group);
                        }}
                        style={{
                          width: '100%',
                          display: 'block',
                          background: `${color}18`,
                          borderLeft: `4px solid ${color}`,
                          borderTop: 'none',
                          borderRight: 'none',
                          borderBottom: 'none',
                          borderRadius: '0 6px 6px 0',
                          padding: '10px 12px',
                          cursor: 'pointer',
                          textAlign: 'left',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: '14px', fontWeight: '700', color }}>Group {group}</span>
                          <span
                            style={{
                              background: color,
                              color: '#fff',
                              borderRadius: '10px',
                              padding: '1px 8px',
                              fontSize: '12px',
                              fontWeight: '700',
                            }}
                          >
                            {selectedDayPopup.dayEvents[group].length}
                          </span>
                        </div>
                        {members && <div style={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>{members}</div>}
                      </button>
                    );
                  })}
                </Box>
              </>
            );
          })()}
      </Dialog>

      <Dialog
        data-id="detail_modal"
        open={Boolean(selectedEvent)}
        onClose={handleClosePop}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        {(() => {
          const groupColor = '#65C8D0';
          const groupMembers = [
            ...new Set(
              (selectedEvent?.event ?? []).flatMap((e) =>
                (e.assigned_members ?? []).map((m) => `${m.first_name} ${m.last_name}`)
              )
            ),
          ];
          return (
            <>
              {/* Colored header */}
              <Box
                sx={{
                  background: groupColor,
                  color: '#fff',
                  px: 2.5,
                  py: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexShrink: 0,
                }}
              >
                <Box>
                  <Typography sx={{ opacity: 0.85, fontSize: '0.7rem', letterSpacing: 1, fontWeight: 600 }}>
                    SCHEDULE DETAILS
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                    Group {selectedEvent?.group}
                  </Typography>
                  <Typography sx={{ opacity: 0.85, fontSize: '0.78rem' }}>
                    {selectedEvent?.event?.length} task{selectedEvent?.event?.length !== 1 ? 's' : ''}
                  </Typography>
                  {groupMembers.length > 0 && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                      {groupMembers.map((name) => (
                        <Box
                          key={name}
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            background: 'rgba(255,255,255,0.18)',
                            border: '1px solid rgba(255,255,255,0.35)',
                            borderRadius: '20px',
                            px: 1,
                            py: '2px',
                          }}
                        >
                          <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#fff', lineHeight: 1 }}>
                            {name}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
                <IconButton size="small" onClick={handleClosePop} sx={{ color: '#fff' }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* Scrollable task list */}
              <Box sx={{ overflowY: 'auto', flex: 1 }}>
                {selectedEvent &&
                  [...selectedEvent.event]
                    .sort((a, b) => (a.sequence_number ?? 0) - (b.sequence_number ?? 0))
                    .map((schedule, index) => (
                      <Accordion
                        key={index}
                        disableGutters
                        elevation={0}
                        sx={{ borderBottom: '1px solid #eee', '&:before': { display: 'none' } }}
                        onChange={(_, expanded) => { if (expanded) fetchCommentCount(schedule._id); }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon sx={{ color: groupColor }} />}
                          sx={{
                            px: 2,
                            py: 0.75,
                            backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#fff',
                            '&:hover': { backgroundColor: '#EAF8F9' },
                            minHeight: 'unset',
                            '& .MuiAccordionSummary-content': { margin: '6px 0' },
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                            <Box
                              sx={{
                                background: getScheduleColor(schedule.estimated_hours, schedule.cost_item),
                                color: '#fff',
                                borderRadius: '4px',
                                px: 0.75,
                                py: 0.25,
                                fontSize: '0.7rem',
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                              }}
                            >
                              {schedule.job_id.number_str}
                            </Box>
                            <Typography
                              sx={{
                                fontSize: '0.78rem',
                                fontWeight: 600,
                                color: '#3DADB5',
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                              }}
                            >
                              {schedule.job_id.locations?.[0]?.city || ''}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '0.82rem',
                                fontWeight: 600,
                                color: '#333',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {schedule.project_managers.map((m) => `${m.first_name} ${m.last_name}`).join(', ')}
                            </Typography>
                          </Box>
                        </AccordionSummary>

                        <AccordionDetails sx={{ px: 2, py: 1.5, backgroundColor: '#fff' }}>
                          <Table size="small">
                            <TableBody>
                              {[
                                ['Task Number', schedule.task.number_str],
                                ['Job Number', schedule.job_id.number_str],
                                ['Client', schedule.client_id.company_name],
                                [
                                  'Location',
                                  [
                                    schedule.job_id.locations?.[0]?.munciple_address,
                                    schedule.job_id.locations?.[0]?.city,
                                    schedule.job_id.locations?.[0]?.state,
                                    schedule.job_id.locations?.[0]?.postal_code,
                                  ]
                                    .filter(Boolean)
                                    .join(', '),
                                ],
                                ['Task Scope', schedule.task.task_scope_id],
                                ['Cost Item', schedule.cost_item[0]],
                              ].map(([label, value]) => (
                                <TableRow
                                  key={label}
                                  sx={{
                                    '&:last-child td': { borderBottom: 0 },
                                    '&:hover': { backgroundColor: '#EAF8F9' },
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      color: '#555',
                                      fontWeight: 600,
                                      fontSize: '0.78rem',
                                      backgroundColor: '#E0F6F8',
                                      borderRight: '1px solid #e0e0e0',
                                      width: '38%',
                                      py: 0.75,
                                    }}
                                  >
                                    {label}
                                  </TableCell>
                                  <TableCell sx={{ fontSize: '0.78rem', color: '#222', py: 0.75 }}>
                                    {value || '—'}
                                  </TableCell>
                                </TableRow>
                              ))}
                              <TableRow sx={{ '&:hover': { backgroundColor: '#EAF8F9' } }}>
                                <TableCell
                                  sx={{
                                    color: '#555',
                                    fontWeight: 600,
                                    fontSize: '0.78rem',
                                    backgroundColor: '#E0F6F8',
                                    borderRight: '1px solid #e0e0e0',
                                    width: '38%',
                                    py: 0.75,
                                  }}
                                >
                                  Document Link
                                </TableCell>
                                <TableCell sx={{ fontSize: '0.78rem', py: 0.75 }}>
                                  {schedule.document_link ? (
                                    <a
                                      href={
                                        /^https?:\/\//i.test(schedule.document_link)
                                          ? schedule.document_link
                                          : `https://${schedule.document_link}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: '#3DADB5', fontWeight: 600, wordBreak: 'break-all' }}
                                    >
                                      {schedule.document_link}
                                    </a>
                                  ) : (
                                    '—'
                                  )}
                                </TableCell>
                              </TableRow>
                              <TableRow sx={{ '&:hover': { backgroundColor: '#EAF8F9' } }}>
                                <TableCell
                                  sx={{
                                    color: '#555',
                                    fontWeight: 600,
                                    fontSize: '0.78rem',
                                    backgroundColor: '#E0F6F8',
                                    borderRight: '1px solid #e0e0e0',
                                    width: '38%',
                                    py: 0.75,
                                    borderBottom: 0,
                                  }}
                                >
                                  Description
                                </TableCell>
                                <TableCell sx={{ fontSize: '0.78rem', color: '#222', py: 0.75, borderBottom: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                  {schedule.description || '—'}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button
                              size="small"
                              variant={commentCounts[schedule._id] > 0 ? 'contained' : 'text'}
                              startIcon={<CommentIcon sx={{ fontSize: '14px !important' }} />}
                              onClick={() => {
                                setSelectedCommentSchedule(schedule);
                                setCommentModal(true);
                              }}
                              sx={
                                commentCounts[schedule._id] > 0
                                  ? {
                                      backgroundColor: '#65C8D0',
                                      color: '#fff',
                                      textTransform: 'none',
                                      fontWeight: 700,
                                      fontSize: '0.75rem',
                                      '&:hover': { backgroundColor: '#3DADB5' },
                                    }
                                  : {
                                      color: '#3DADB5',
                                      textTransform: 'none',
                                      fontWeight: 600,
                                      fontSize: '0.75rem',
                                      '&:hover': { backgroundColor: '#E0F6F8' },
                                    }
                              }
                            >
                              {commentCounts[schedule._id] > 0 ? `Comments (${commentCounts[schedule._id]})` : 'Comments'}
                            </Button>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    ))}
              </Box>
            </>
          );
        })()}
      </Dialog>
    </div>
  );
}
